module.exports = __webpack_public_path__ + "img/business4.6e13e89e.png";